import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Card, CardBody } from 'reactstrap'

import CustomersTable from '../Customers/partials/CustomersTable'
import ListTopBar from '../../components/ListTopBar'

import { getCrmCustomers } from '../Customers/services'
import { handleError, parsePagination } from '../../helpers'
import SegmentsSelect from './partials/SegmentsSelect'

export default function SegmentsList() {
	const user = useSelector(state => state.auth.user)
	const [customers, setCustomers] = useState(null)
	const [filterType, setFilterType] = useState('name')
	const [filterValue, setFilterValue] = useState('')
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})
	const [segmentFilters, setSegmentFilters] = useState({})

	useEffect(() => {
		const allowedAllUsers = [ '45529926', '52997820', '10322441917', '1072709711' ]

		!customers && getCrmCustomers({
			[`filter[${filterType}]`]: filterValue,
			'filter[active_in_store_id]': !allowedAllUsers.includes(user.document) ? user.current_store : null,
			'filter[active_channels]': 'call',
			sort: '-created_at',
			include: 'invoicesCount,callsLogsCount,whatsappClickLogsCount',
			...pagination,
			...segmentFilters
		})
			.then(res => {
				setCustomers(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ customers, filterType, filterValue, pagination, user, segmentFilters ])

	return (
		<React.Fragment>
			<ListTopBar 
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				title={`Clientes del Segmento`}
				subtitle="Momentos Spring"
				reload={() => setCustomers(null)}
				options={[
					{ label: 'Buscar por nombre', value: 'name' },
					{ label: 'Buscar por cédula', value: 'document' },
					{ label: 'Buscar por número de factura', value: 'invoices.reference' },
					{ label: 'Buscar por producto comprado', value: 'invoices.products.description' },
				]}
			/>
			<Card>
				<CardBody>
					<SegmentsSelect
						setSegmentFilters={setSegmentFilters}
						reload={() => setCustomers(null)}
					/>
					<CustomersTable
						customers={customers}
						reload={() => setCustomers(null)}
						pagination={pagination}
						setPagination={setPagination}
					/>
				</CardBody>
			</Card>
		</React.Fragment>
	)
}